import { Divider, Switch, TimePicker, Typography } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import styles from "./set-preference.module.css";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const SetPreference = ({ loading, onChange }) => {
  const [formData, setFormData] = useState({
    daily_schedule: null,
    marking_window: { from: null, to: null },
    automated_teacher_alert: false,
    share_report: false,
    remind_teacher: false,
  });

  useEffect(() => {
    onChange(formData);
  }, [formData, onChange]);

  const handleTimeChange = (field, time) => {
    const formattedTime = time ? dayjs(time).format("HH:mm") : null;
    if (field.includes(".")) {
      const [parent, child] = field.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: { ...prev[parent], [child]: formattedTime },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: formattedTime }));
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_row}>
        <Typography>Schedule daily reminder for marking</Typography>
        <TimePicker
          value={
            formData.daily_schedule
              ? dayjs(formData.daily_schedule, "HH:mm")
              : null
          }
          onChange={(time) => handleTimeChange("daily_schedule", time)}
          format="HH:mm"
        />
      </div>
      <Divider className={styles.divider} />

      {/* Attendance Window */}
      <div className={styles.container_row}>
        <Typography>Define attendance window marking</Typography>
        <TimePicker
          value={
            formData.marking_window.from
              ? dayjs(formData.marking_window.from, "HH:mm")
              : null
          }
          onChange={(time) => handleTimeChange("marking_window.from", time)}
          format="HH:mm"
        />
        <TimePicker
          value={
            formData.marking_window.to
              ? dayjs(formData.marking_window.to, "HH:mm")
              : null
          }
          onChange={(time) => handleTimeChange("marking_window.to", time)}
          format="HH:mm"
        />
      </div>
      <Divider className={styles.divider} />

      <div className={styles.container_row}>
        <Typography>Automated Teacher Alerts</Typography>
        <Switch
          checked={formData.automated_teacher_alert}
          onChange={(checked) =>
            setFormData((prev) => ({
              ...prev,
              automated_teacher_alert: checked,
            }))
          }
        />
      </div>
      <Divider className={styles.divider} />

      <div className={styles.container_row}>
        <Typography>Send Completed reports to other admins</Typography>
        <Switch
          checked={formData.share_report}
          onChange={(checked) =>
            setFormData((prev) => ({ ...prev, share_report: checked }))
          }
        />
      </div>
      <Divider className={styles.divider} />

      <div className={styles.container_row}>
        <Typography>Remind Teachers</Typography>
        <Switch
          checked={formData.remind_teacher}
          onChange={(checked) =>
            setFormData((prev) => ({ ...prev, remind_teacher: checked }))
          }
        />
      </div>
    </div>
  );
};

export default SetPreference;
